// ignore-string-externalization
import {
  createBaseTransport,
  TransportEvent,
} from '@spotify-internal/transport';
import { tokenProvider } from '../auth';

// https://backstage.spotify.net/docs/js-sdk-transport/manual/instantiating/#creating-transport-instances
export const transport = createBaseTransport({
  providers: {
    async endpoints() {
      return {
        webgate: 'https://generic.wg.spotify.com',
        webapi: 'https://api.spotify.com',
      };
    },
    token: tokenProvider,
  },
});

// https://backstage.spotify.net/docs/js-sdk-transport/manual/lifecycle/#authentication
transport.on(TransportEvent.CONNECTED, () => {
  // Authenticate after connection
  transport.authenticate().catch(() => {});
});

// do not connect in tests
if (process.env.NODE_ENV !== 'test' && typeof window === 'object') {
  transport.connect();
}
